import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TextButton } from '../Button/TextButton/TextButton-CgSjDrqi.js';
import { I as Icon } from '../Icon/Icon-DowU4ANk.js';
import { f as angleUp, g as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

const IconWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tb9hgd-0"
})(["display:flex;color:", ";width:14px;padding-inline-end:", ";flex:0 0 auto;"], ({
  theme
}) => theme.icon.color, ({
  theme
}) => theme.spacing.mini);
const ExtenderButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30054544__sc-tb9hgd-1"
})(["display:flex;justify-content:flex-start;align-items:stretch;text-align:initial;:hover{> ", "{color:", ";}}", ""], IconWrapper, ({
  theme
}) => theme.icon.hover.color, isMobile(css(["margin:10px auto;"])));
ExtenderButton.displayName = 'ExtenderButton';
const TextButtonLabel = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tb9hgd-2"
})(["flex:1 1 auto;"]);
const ExtenderContent = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tb9hgd-3"
})(["display:", ";"], ({
  isOpen
}) => isOpen ? 'block' : 'none');
ExtenderContent.displayName = 'ExtenderContent';
const Extender = ({
  children,
  handleClick,
  isOpen,
  label,
  triggerProps = {},
  ...rest
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ExtenderContent, _extends({}, rest, {
  isOpen: isOpen
}), children), /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({}, triggerProps, {
  onClick: handleClick,
  tabindex: "0",
  "aria-expanded": isOpen
}), /*#__PURE__*/React__default.createElement(IconWrapper, null, isOpen ? /*#__PURE__*/React__default.createElement(Icon, {
  type: angleUp,
  size: "sm"
}) : /*#__PURE__*/React__default.createElement(Icon, {
  type: angleDown,
  size: "sm"
})), /*#__PURE__*/React__default.createElement(TextButtonLabel, null, label)));
Extender.propTypes = {
  /**
   * The content within the Extender.
   */
  children: PT.node.isRequired,
  /**
   * The Extender Button label.
   */
  label: PT.node.isRequired,
  /**
   * Denotes if the InlineExapnder is open or closed.
   */
  isOpen: PT.bool.isRequired,
  /**
   * The click event handler. Used to toggle state.
   */
  handleClick: PT.func,
  /**
   * Additional props to be passed to the triggering text button.
   */
  triggerProps: PT.object // eslint-disable-line react/forbid-prop-types
};
Extender.defaultProps = {
  handleClick: () => undefined,
  triggerProps: {}
};

export { Extender as E };
//# sourceMappingURL=Extender-B1tKXSUo.js.map
